export const STATUS = {
  green: { label: "Actief", en: "Active", dot: "bg-emerald-500", text: "text-emerald-500", ring: "ring-emerald-500/30", bg: "bg-emerald-500/10" },
  orange: { label: "Waarschuwing", en: "Warning", dot: "bg-amber-500", text: "text-amber-500", ring: "ring-amber-500/30", bg: "bg-amber-500/10" },
  blue: { label: "Filteren actief", en: "Filtering", dot: "bg-blue-500", text: "text-blue-500", ring: "ring-blue-500/30", bg: "bg-blue-500/10" },
  red: { label: "Kritiek", en: "Critical", dot: "bg-red-500", text: "text-red-500", ring: "ring-red-500/30", bg: "bg-red-500/10" },
  grey: { label: "Geen signaal", en: "No signal", dot: "bg-slate-400", text: "text-slate-400", ring: "ring-slate-400/30", bg: "bg-slate-400/10" },
};

export function statusLabel(color, lang) {
  const s = STATUS[color] || STATUS.grey;
  return lang === "en" ? s.en : s.label;
}

export function fmtDate(iso, lang = "nl") {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(lang === "en" ? "en-GB" : "nl-NL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
}

export function fmtRelative(iso, lang = "nl") {
  const en = lang === "en";
  if (!iso) return en ? "Never" : "Nooit";
  const diff = Date.now() - new Date(iso).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return en ? "Just now" : "Zojuist";
  if (m < 60) return en ? `${m} min ago` : `${m} min geleden`;
  const h = Math.floor(m / 60);
  if (h < 24) return en ? `${h} h ago` : `${h} uur geleden`;
  const d = Math.floor(h / 24);
  if (en) return `${d} day${d > 1 ? "s" : ""} ago`;
  return `${d} dag${d > 1 ? "en" : ""} geleden`;
}

export const METRIC_EN = {
  ISO_4um: "ISO >4 µm", ISO_6um: "ISO >6 µm", ISO_14um: "ISO >14 µm",
  cs_temperature_c: "CS temperature",
  conductivity_ns_m: "Conductivity", change_conductivity_pct: "Δ Conductivity",
  relative_permittivity: "Relative permittivity", low_saturation_pct_rh: "Moisture", temperature_c: "HLB temperature",
  motor_on: "Motor", warmup: "Warming up", cs_ok: "CS", hlb_ok: "HLB", data_ok: "Data quality",
  status: "System status", fault_code: "Fault code", uptime_seconds: "Uptime",
  starting_countdown_s: "Startup countdown", cs_fail_count_today: "CS faults today",
  hlb_fail_count_today: "HLB faults today", revpi_faults_today: "RevPi faults today",
  checksum: "Checksum", data_id: "Data ID",
};

export function metricLabel(key, fallbackNl, lang) {
  if (lang === "en" && METRIC_EN[key]) return METRIC_EN[key];
  return fallbackNl;
}

const STATE_EN = { "OK": "OK", "Wacht": "Waiting", "Aan": "On", "Uit": "Off", "Gereed": "Ready", "Opwarmen": "Warming up", "Fout": "Fault", "Data OK": "Data OK", "Geen data": "No data" };

export function stateText(text, lang) {
  return lang === "en" && STATE_EN[text] ? STATE_EN[text] : text;
}

const PROCESS_STATE_NL = {
  WAITING: "Wachten", WARMUP: "Opwarmen", MEASURING: "Meten",
  FILTERING: "Filteren", FAULT: "Storing", MANUAL: "Handmatig",
};

const NEXT_ACTION_NL = {
  WAIT: "Wachten", START_FILTERING: "Filteren starten", CONTINUE_FILTERING: "Filteren voortzetten",
  REMEASURE: "Opnieuw meten", RETRY_SENSOR: "Sensor opnieuw proberen",
  STOP_FAULT: "Stoppen na storing", START_MEASURING: "Meten starten",
};

export function processStateText(value, lang = "nl") {
  if (!value) return "—";
  return lang === "en" ? value : (PROCESS_STATE_NL[value] || value);
}

export function nextActionText(value, lang = "nl") {
  if (!value) return "—";
  return lang === "en" ? value : (NEXT_ACTION_NL[value] || value);
}

export function fmtVal(v) {
  return v === null || v === undefined ? "—" : Number(v).toFixed(1);
}

export function fmtBytes(value, lang = "nl") {
  const bytes = Number(value);
  if (!Number.isFinite(bytes) || bytes < 0) return "—";
  const units = ["B", "kB", "MB", "GB", "TB"];
  let amount = bytes;
  let index = 0;
  while (amount >= 1000 && index < units.length - 1) {
    amount /= 1000;
    index += 1;
  }
  return `${amount.toLocaleString(lang === "en" ? "en-GB" : "nl-NL", { maximumFractionDigits: index === 0 ? 0 : 2 })} ${units[index]}`;
}

export function fmtCountdown(iso, lang = "nl") {
  if (!iso) return null;
  const en = lang === "en";
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return en ? "any moment" : "elk moment";
  const s = Math.round(diff / 1000);
  if (s < 90) return en ? `in ${s}s` : `over ${s}s`;
  const m = Math.round(s / 60);
  if (m < 90) return en ? `in ${m} min` : `over ${m} min`;
  const h = Math.round(m / 60);
  return en ? `in ${h} h` : `over ${h} u`;
}
